<template>
  <v-app>
    <v-container
      v-if="fullPageLoading"
      fluid
      style="
        height: 100vh;
        width: 100%;
        padding: 0;
        background-color: white;
        overflow: hidden;
        border-radius: 10px;
      "
    >
      <HomePageSkeleton />
    </v-container>
    <div v-else class="main-div analog-layout" style="overflow-y: hidden; height: 100vh">
      <header class="analog-topbar">
        <img :src="logo" alt="Maira Voice" class="analog-topbar-logo" />
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark v-bind="attrs" v-on="on" class="profile-menu-btn">
              <v-avatar size="32">
                <v-icon color="white">mdi-account-circle</v-icon>
              </v-avatar>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item disabled>
              <v-list-item-content>
                <v-list-item-title class="primary--text font-weight-bold"
                  >{{ userProfile?.first_name }}
                  {{ userProfile?.middle_name }}
                  {{ userProfile?.last_name }}
                </v-list-item-title>
                <v-list-item-subtitle class="blackDark--text">{{
                  userProfile?.email
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="logout">
              <span class="me-2">
                <v-icon>mdi-logout</v-icon>
              </span>
              <v-list-item-title>ログアウト</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </header>

      <div class="main-section analog-main-section">
        <v-container fluid>
          <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            :color="snackbarColor"
            top
          >
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
              <v-btn
                text
                v-bind="attrs"
                @click="snackbar = false"
                class="pa-0 ma-0"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>

          <div class="main-header py-2 px-0 border-bottom-lightblue">
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex align-center justify-start">
                <div class="me-2">
                  <v-btn icon color="primary" @click="refreshCallList">
                    <img :src="refreshSVG" alt="refresh" />
                  </v-btn>
                </div>
                <div style="border-right: 1px solid #aaaaaa; height: 20px"></div>
                <div class="ms-2">
                  <p class="table-title">すべての顧客セッション</p>
                  <p class="table-subtitle">すべての顧客セッションの詳細リスト</p>
                </div>
              </div>
            </div>

            <div
              :class="['d-flex','align-center', $vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row']"
            >
              <template>
                <!-- <div v-if="isAdmin" class="d-flex align-center">
                  <span class="mr-2"> N/Aコールを表示 </span>
                  <v-switch v-model="toggleNaSwitch"></v-switch>
                </div>
                <div class="bar mx-2" v-if="!$vuetify.breakpoint.xsOnly"></div> -->
                <div
                  v-if="isAdmin && selectedCalls.length"
                  class="delete-call-details"
                  @click="deleteBulkDialog = true"
                  :style="$vuetify.breakpoint.xsOnly ? 'margin-bottom: 8px;' : ''"
                >
                  <img :src="deleteIcon" alt="delete" class="cursor-pointer" />
                  <span class="delete-btn">削除 ({{ selectedCalls.length }})</span>
                </div>
                <div
                  class="bar mx-2"
                  v-if="!$vuetify.breakpoint.xsOnly && isAdmin && selectedCalls.length"
                ></div>
                <v-card
                  flat
                  class="pa-1 d-flex align-center justify-space-between"
                  :style="$vuetify.breakpoint.xsOnly
                    ? 'background-color: #f8f9fa; width: 100%; height: 40px; margin-bottom: 8px'
                    : $vuetify.breakpoint.smOnly
                    ? 'background-color: #f8f9fa; width: 100%; height: 40px'
                    : 'background-color: #f8f9fa; width: 260px; height: 40px'"
                >
                  <v-icon class="ms-3 me-2" size="20">mdi-magnify</v-icon>
                  <input
                    ref="searchField"
                    v-model="searchText"
                    class="search-input"
                    type="text"
                    hide-details
                    outlined
                    dense
                    clearable
                    @keydown="handleSearch"
                    @compositionstart="isComposing = true"
                    @compositionend="isComposing = false"
                    placeholder="すべての情報から探す"
                    style="flex:1; min-width:0; border:none; outline:none; background:transparent"
                  />
                  <v-btn
                    icon
                    size="small"
                    variant="text"
                    class="search-filter-btn"
                    @click="openFilter"
                  >
                    <v-icon>mdi-tune</v-icon>
                  </v-btn>
                </v-card>
              </template>

              <div class="mx-2 bar" v-if="!$vuetify.breakpoint.xsOnly"></div>
              <v-menu
                offset-y
                :style="$vuetify.breakpoint.xsOnly ? 'width:100%; margin-bottom:8px' : $vuetify.breakpoint.smOnly ? 'width:calc(50% - 8px)' : 'width:200px'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="call-filter align-center d-flex mt-2 mt-sm-0"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    :style="$vuetify.breakpoint.xsOnly ? 'width:100%' : $vuetify.breakpoint.smOnly ? 'width:100%' : 'width:200px'"
                  >
                    {{
                      callStatus.find(
                        (state) => state.value === selectedCallStatus
                      ).text
                    }}
                  </span>
                </template>
                <v-list class="call-filter-list">
                  <v-list-item
                    v-for="state in callStatus"
                    :key="state.value"
                    :disabled="state.value !== 'finished'"
                    @click="selectedCallStatus = state.value"
                  >
                    <v-list-item-title>{{ state.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <!-- Divider only makes sense when the switcher is actually shown. -->
              <div
                class="mx-2 bar"
                v-if="showProjectSwitcher && !$vuetify.breakpoint.smAndDown"
              ></div>
              <ProjectSwitcher class="mt-2 mt-sm-0" />
            </div>
          </div>

          <template v-if="openSearchFilter">
            <div class="pa-2 mb-2 border-bottom-lightblue filter-field-section">
              <FilterFields
                :filters="filters"
                :fields="filterFields"
                @change="handleInputChange"
                @openFilter="openFilter"
              />
            </div>
          </template>

          <v-row>
            <v-col cols="12">
              <div class="call-table">
                <v-data-table
                  v-model="selectedCalls"
                  :show-select="isAdmin && (calls?.length > 0)"
                  item-key="session_id"
                  :headers="headers"
                  :items="calls"
                  :loading="loading"
                  :server-items-length="totalCalls"
                  @update:options="options = $event"
                  :options="options"
                  :footer-props="{
                    itemsPerPageOptions: [10, 25, 50, 100],
                    showFirstLastPage: true,
                  }"
                  hide-default-footer
                  no-data-text="データがありません"
                  class="custom-table-checkbox"
                >
                  <template v-slot:[`header.session_id`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>
                  <template v-slot:[`header.dest_department`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>
                  <template v-slot:[`header.conversation_title`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>
                  <template v-slot:[`header.caller`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>
                  <template v-slot:[`header.receiver`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>
                  <template v-slot:[`header.date`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>
                  <template v-slot:[`header.call_time`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>
                  <template v-slot:[`header.call_length`]="{ header }">
                    <div class="table-header-custom-title d-flex align-center">
                      <div :class="headerActiveStatus(header.sortOrder)">{{ header.text }}</div>
                      <Icon name="dropdown" color="gray" width="14" height="14"
                        :upColor="header.sortOrder == 'asc' ? 'black' : 'gray'"
                        :downColor="header.sortOrder == 'desc' ? 'black' : 'gray'" />
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
                  </template>
                  <template v-slot:[`item.session_id`]="{ item }">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <span @click="copyToClipboard(item.session_id)" class="cursor-pointer">
                            {{ item.session_id.slice(0, 16)
                            }}{{ item.session_id.length > 16 ? "..." : "" }}
                          </span>
                        </span>
                      </template>
                      <span>{{ item.session_id }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.dest_department`]="{ item }">
                    <span>{{ item?.dest_department || "N/A" }}</span>
                  </template>
                  <template v-slot:[`item.conversation_title`]="{ item }">
                    <v-tooltip right v-if="item?.conversation_title">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <span class="cursor-pointer">
                            {{ item?.conversation_title.slice(0, 8) }}
                            {{ item?.conversation_title.length > 8 ? "..." : "" }}
                          </span>
                        </span>
                      </template>
                      <span style="display: inline-block; width: 250px; white-space: normal;">
                        {{ item?.conversation_title }}
                      </span>
                    </v-tooltip>
                    <span v-else>N/A</span>
                  </template>
                  <template v-slot:[`item.caller`]="{ item }">
                    <span>{{ handlePhoneNumberFormat(item?.src_id) || "N/A" }}</span>
                  </template>
                  <template v-slot:[`item.receiver`]="{ item }">
                    <span>{{ handlePhoneNumberFormat(item?.dest_id) || "N/A" }}</span>
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    <span>{{ new Date(item.date).toLocaleDateString("en-CA") }}</span>
                  </template>
                  <template v-slot:[`item.call_time`]="{ item }">
                    <div :class="$vuetify.breakpoint.smAndDown ? 'd-flex justify-start' : ''">
                      <span
                        :class="`call-status
                          ${
                            item.call_status === 'finished'
                              ? 'finished'
                              : item.call_type === 'incoming'
                              ? 'incoming'
                              : 'outgoing'
                          }`"
                      >
                        <img
                          v-if="item.call_type"
                          :src="item.call_type === 'incoming' ? incomingCallIcon : item.call_type === 'outgoing' ? outgoingCallIcon : ''"
                          alt="call type"
                          style="height: 16px; width: 16px"
                        />
                      </span>
                      <p class="ma-0 text-caption">
                        {{
                          item.start_time
                            ? new Date(item.start_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })
                            : "N/A"
                        }}
                        -
                        {{
                          item.end_time
                            ? new Date(item.end_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })
                            : "録音中"
                        }}
                      </p>
                    </div>
                  </template>
                  <template v-slot:[`item.call_length`]="{ item }">
                    <span
                      :class="`call-status
                        ${
                          item.call_status === 'finished'
                            ? 'finished'
                            : item.call_type === 'incoming'
                            ? 'incoming'
                            : 'outgoing'
                        }`"
                    >
                      <img
                        v-if="item.call_type"
                        :src="item.call_type === 'incoming' ? incomingCallIcon : item.call_type === 'outgoing' ? outgoingCallIcon : ''"
                        alt="call type"
                        style="height: 16px; width: 16px"
                      />
                      <span>{{ getDuration(item.start_time, item.end_time) }}</span>
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item, index }">
                    <div class="d-flex align-center">
                      <div
                        class="border pa-2 d-flex align-center cursor-pointer me-2"
                        @click="initiatedCall(item)"
                      >
                        <img :src="eyeIcon" alt="eye" style="height: 18px; width: 18px" />
                      </div>
                      <template>
                        <div
                          v-if="callIndexDownloadLoader[index]"
                          class="border pa-2 d-flex align-center"
                        >
                          <v-progress-circular indeterminate size="15" color="grey darken-1"></v-progress-circular>
                        </div>
                        <div
                          v-else
                          class="border pa-2 d-flex align-center"
                          :disabled="item.audio_file_path"
                          @click="downloadFile(item, index)"
                          target="_blank"
                          :class="`me-2 ${item.audio_file_path ? 'cursor-pointer' : 'disabled'} `"
                        >
                          <Icon name="download" :color="item.audio_file_path ? 'gray' : '#E2E8F0'" width="14" height="14" />
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-slot:footer>
                    <div class="footer-fixed">
                      <v-pagination
                        color="hover"
                        :total-visible="8"
                        v-model="options.page"
                        :length="Math.ceil(totalCalls / options.itemsPerPage)"
                        @input="getCallList"
                      ></v-pagination>
                      <div>
                        <span>{{ pageRangePagination(options.page, options.itemsPerPage, totalCalls) }} </span>
                        <span>
                          <select
                            style="width: max-content; padding-right: 30px"
                            v-model="options.itemsPerPage"
                            class="call-filter"
                            @change="refreshCallList"
                          >
                            <option
                              class="call-filter-item"
                              v-for="item in [10, 25, 50, 100]"
                              :key="item"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                        </span>
                        <span> 件表示 </span>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <!-- Delete Call Dialog -->
    <v-dialog v-model="deleteDialog" class="delete-dialog" width="448">
      <v-card>
        <v-card-title class="headline justify-space-between" style="font-size: 20px; font-weight: 500">
          削除の確認
          <v-icon class="cursor-pointer" @click="deleteDialog = false; selectedSessionId = '';">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="delete-dialog-text">
          <img :src="trashCanIcon" alt="" style="height: 60px; width: 60px" />
          <p style="font-size: 15px; font-weight: 400; color: #3f4652; margin-top: 24px;">
            この通話を削除しますか？
          </p>
        </v-card-text>
        <v-card-actions class="justify-space-around pb-5">
          <v-btn class="no-btn-delete" @click="deleteDialog = false; selectedSessionId = '';">
            キャンセル
          </v-btn>
          <v-btn class="yes-btn-delete" @click="deleteCallFunction">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Bulk Call Dialog -->
    <v-dialog v-model="deleteBulkDialog" :persistent="isBulkDeleting" class="delete-dialog" width="448">
      <v-card>
        <v-card-title class="headline justify-space-between" style="font-size: 20px; font-weight: 500">
          削除の確認
        </v-card-title>
        <v-card-text class="delete-dialog-text">
          <img :src="trashCanIcon" alt="" style="height: 60px; width: 60px" />
          <p style="font-size: 15px; font-weight: 400; color: #3f4652; margin-top: 24px;">
            選択した{{ selectedCalls.length }}件の通話を削除しますか？
          </p>
        </v-card-text>
        <v-card-actions class="justify-space-around pb-5">
          <v-btn class="no-btn-delete" :disabled="isBulkDeleting" @click="deleteBulkDialog = false">
            キャンセル
          </v-btn>
          <v-btn class="yes-btn-delete" :loading="isBulkDeleting" @click="deleteBulkCallsFunction">
            削除する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import logo from "@/assets/images/maira_voice_logo.svg";
import refreshSVG from "@/assets/images/refresh.svg";
import eyeIcon from "@/assets/images/eye.svg";
import incomingCallIcon from "@/assets/images/incoming.svg";
import outgoingCallIcon from "@/assets/images/outgoing.svg";
import trashCanIcon from "@/assets/images/trashCan.svg";
import deleteIcon from "@/assets/images/Delete.svg";
import HomePageSkeleton from "@/components/HomePageSkeleton.vue";
import FilterFields from "@/components/CallFilterFields.vue";
import ProjectSwitcher from "@/components/ProjectSwitcher.vue";
import callListMixin from "@/mixins/callListMixin";
import { debounce } from "@/utils/debounceFields";
import { Icon } from "@/assets/icons";
import { interactionUpdate } from "@/helpers/helper";
import { INTERACTION_POINT } from "@/global/_constants";

export default {
  name: "AnalogPage",

  mixins: [callListMixin],

  components: {
    HomePageSkeleton,
    FilterFields,
    ProjectSwitcher,
    Icon,
  },
  computed: {
    ...mapGetters("account", ["userProfile", "isAdmin"]),
    ...mapGetters("project", ["activeProjectId", "showProjectSwitcher"]),
    ...mapState({
      user: (state) => state.account.user,
    }),
  },
  data() {
    return {
      fullPageLoading: false,
      isComposing: false,
      logo,
      eyeIcon,
      deleteIcon,
      toggleNaSwitch: true,
      incomingCallIcon,
      outgoingCallIcon,
      refreshSVG,
      trashCanIcon,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "",
      callStatus: [
        { text: "録音中", value: "on_going" },
        { text: "完了", value: "finished" },
        { text: "すべて", value: "all" },
      ],
      selectedCallStatus: "finished",
      searchText: "",
      headers: [
        { text: "No.", value: "index", sortable: false, width: "4%", class: "index-col", cellClass: "index-col" },
        { text: "管理番号", value: "session_id", sortable: true },
        { text: "タイトル", value: "conversation_title", sortable: true },
        { text: "発信者", value: "caller", sortable: true },
        { text: "着信先", value: "receiver", sortable: true },
        { text: "部門", value: "dest_department", sortable: true },
        { text: "日付", value: "date", sortable: true },
        { text: "通話時間帯", value: "call_time", sortable: true },
        { text: "通話時間", value: "call_length", sortable: true },
        { text: "操作", value: "actions", sortable: false },
      ],
      calls: [],
      loading: false,
      totalCalls: 0,
      options: {
        itemsPerPage: 10,
        page: 1,
      },
      selectedCalls: [],
      deleteDialog: false,
      deleteBulkDialog: false,
      selectedSessionId: "",
      isBulkDeleting: false,
      bulkDeleteTaskId: "",
      bulkDeleteInterval: null,
      recordingRefreshInterval: null,
      callIndexDownloadLoader: [],
      openSearchFilter: false,
      debouncedProcess: null,
      debounceInteractionUpdate: null,
      filters: {
        title: "",
        caller: "",
        receiver: "",
        dateRange: "",
        call_time: { start_date: "", end_date: "" },
        date: { start_date: "", end_date: "" },
        call_length: { start: "", end: "" },
        call_text: "",
        call_summary_text: "",
      },
      filterFields: [
        { label: "タイトル", model: "title", icon: "mdi-email" },
        { label: "発信者", model: "caller", icon: "mdi-phone" },
        { label: "通話テキスト", model: "call_text", icon: "mdi-message-text" },
        { label: "通話概要テキスト", model: "call_summary_text", icon: "mdi-text-box-search" },
        { label: "着信先", model: "receiver", icon: "mdi-city" },
        { label: "日付範囲", model: "date", icon: "mdi-calendar" },
        { label: "通話時刻帯", model: "call_time", icon: "mdi-calendar" },
        { label: "通話時間", model: "call_length", icon: "mdi-timer-sand" },
      ],
      sortBy: "",
      sortDesc: false,
      search_filter: {},
    };
  },

  watch: {
    options: {
      async handler(newVal, oldVal) {
        if (
          JSON.stringify(newVal.sortBy) !== JSON.stringify(oldVal.sortBy) ||
          JSON.stringify(newVal.sortDesc) !== JSON.stringify(oldVal.sortDesc)
        ) {
          if (newVal.sortBy[0] == "call_time") {
            this.sortBy = "start_time";
          } else {
            this.sortBy = newVal.sortBy[0];
          }
          this.sortDesc = newVal.sortDesc[0];
          this.sortDataFunction(newVal.sortBy[0]);
          await this.$nextTick();
        }

        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          if (!this.fullPageLoading) {
            this.getCallList();
          }
        }
      },
      deep: true,
    },
    selectedCallStatus() {
      this.refreshCallList();
      interactionUpdate(INTERACTION_POINT.APPLY_FILTER, "call_status_dropdown", this.selectedCallStatus || "default");
    },
    activeProjectId() {
      this.selectedCalls = [];
      this.refreshCallList();
    },
    searchText() {
      if (!this.searchText) {
        this.refreshCallList();
      }
    },
    toggleNaSwitch() {
      this.refreshCallList();
    },
  },
  mounted() {
    this.recordingRefreshInterval = setInterval(() => {
      if (!this.calls.some((call) => !call.end_time)) return;
      this.calls.forEach((call, index) => {
        if (!call.end_time) {
          this.$set(this.calls, index, { ...call });
        }
      });
    }, 1000);
  },
  created() {
    this.debouncedProcess = debounce(this.refreshCallList, 500);
    this.debounceInteractionUpdate = debounce(() => {
      interactionUpdate(
        INTERACTION_POINT.APPLY_FILTER,
        "manual_search",
        JSON.stringify(this.search_filter) || "default"
      );
    }, 700);
  },
  beforeUnmount() {
    if (this.recordingRefreshInterval) clearInterval(this.recordingRefreshInterval);
    if (this.bulkDeleteInterval) clearInterval(this.bulkDeleteInterval);
  },
  methods: {
    async getCallList() {
      this.loading = true;
      try {
        this.RETRIEVE_CALLS({
          call_status: this.selectedCallStatus,
          search: this.searchText,
          start: (this.options.page - 1) * this.options.itemsPerPage || 0,
          size: this.options.itemsPerPage || 5,
          search_filter: this.search_filter,
          sort_field: this.sortBy,
          sort_order: this.sortDesc ? "desc" : "asc",
          toggleNaSwitch: this.toggleNaSwitch,
        }).then((response) => {
          if (response) {
            this.calls = response.calls || [];
            this.totalCalls = response.total_hits;
            this.callIndexDownloadLoader = (response.calls || []).map(() => false);
          }
          this.loading = false;
        });
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.main-div {
  display: flex;
  background-color: #0b131c;
}
.disabled {
  color: #cccccc;
}

.analog-layout {
  flex-direction: column;
}
.analog-topbar {
  flex-shrink: 0;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.analog-topbar-logo {
  height: 24px;
  width: auto;
  display: block;
}

.main-section {
  width: 100%;
  height: 100vh;
  padding: 0px;
  margin: 8px;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  position: relative;
}

.analog-layout .analog-main-section {
  width: auto;
  height: auto;
  flex: 1 1 auto;
  min-height: 0;
  margin: 0 8px 8px;
}

.footer-fixed {
  position: absolute;
  bottom: 0;
  left: 50%;
  right: 50%;
  transform: translateX(-50%);
  width: 100%;
  background: white;
  border-top: 1px solid #e2e8f0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 8px 8px;
}
.main-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.table-title {
  font-size: 16px;
  font-weight: 500;
  color: #194fa2;
  margin: 0;
  padding: 0;
}
.table-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #3f4652;
  margin: 0;
  padding: 0;
}
.call-filter {
  width: 200px;
  height: 40px;
  border-radius: 8px;
  padding: 0 16px;
  border-width: 0.5px;
  background: #ffffff33;
  border: 0.5px solid #cccccc;
  backdrop-filter: blur(20px);
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23222222'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}
.call-filter-list {
  padding: 5px;
  background: white;
}
.delete-dialog {
  border-radius: 16px !important;
  padding: 24px 24px 32px 24px !important;
  border: 4px solid #e2e8f0 !important;
  box-shadow: 0px 0px 20px 0px #1e1e1e05;
  backdrop-filter: blur(20px);
}
.delete-dialog-text {
  font-size: 15px;
  font-weight: 400;
  color: #3f4652;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px !important;
}
.no-btn-delete {
  width: 30% !important;
  border-radius: 6px !important;
  border-width: 1px !important;
  background-color: #e4e4e4 !important;
  color: #3f4652 !important;
  box-shadow: none !important;
}
.yes-btn-delete {
  width: 30% !important;
  border-radius: 6px !important;
  background-color: #ef3939 !important;
  color: white !important;
  box-shadow: none !important;
}
@media (max-width: 768px) {
  .main-div {
    flex-direction: column;
  }
  .main-section {
    width: 100%;
    height: calc(100vh - 20px);
    margin: 10px 0;
  }
  .main-header {
    flex-direction: column;
  }
  .footer-fixed {
    flex-direction: column;
    align-items: center;
  }
}
.custom-table-checkbox >>> .v-data-table__checkbox {
  transform: scale(0.8);
}
</style>
